<template>
  <div class="mf-materials-pagination">
    <button
      class="mf-materials-pagination-prev"
      aria-label="Zurück"
      :disabled="currentPage === 1"
      @click="prevPage"
    />
    <div class="mf-materials-pagination-info">
      <span class="current">{{ currentPage }}</span>
      <span class="seperator">von</span>
      <span class="total">{{ totalPages }}</span>
    </div>
    <button
      class="mf-materials-pagination-next"
      aria-label="Weiter"
      :disabled="currentPage === totalPages"
      @click="nextPage"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from "vue";

const properties = defineProps({
  totalItems: {
    type: Number,
    required: true,
  },
  itemsPerPage: {
    type: Number,
    default: 10,
  },
  modelValue: {
    type: Number,
    default: 1,
  },
});

const emit = defineEmits(["update:modelValue"]);

const currentPage = ref(properties.modelValue);

const totalPages = computed(() => {
  return Math.ceil(properties.totalItems / properties.itemsPerPage);
});

const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
};

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
};

watch(currentPage, (newPage) => {
  emit("update:modelValue", newPage);
});
watch(totalPages, (newTotalPages) => {
  if (currentPage.value > newTotalPages) {
    currentPage.value = newTotalPages;
  }
});
watch(() => properties.modelValue, (newModelValue) => {
  currentPage.value = newModelValue;
});
</script>
